<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fill-rule="evenodd">
            <circle cx="7.947" cy="7.947" r="7.947" fill="#FFF"/>
            <g fill="#44B358" transform="translate(3.866 5.584)">
                <rect width="5.884" height="4.576" rx="2"/>
                <path d="M6.644.746l1.18-.472c.256-.102.547.022.65.279.023.059.035.122.035.186v3.099c0 .276-.224.5-.5.5-.063 0-.126-.012-.185-.036l-1.18-.472c-.19-.076-.314-.26-.314-.464V1.21c0-.204.125-.388.314-.464z"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'video-start-icon'
}
</script>
